import { type UserPreferences } from './authTypes.ts';

export const isSubscribedToEmails = (preferences: UserPreferences | null | undefined): boolean => {
    const emailOptInPreferences = [
        'customOffers',
        'orderFeedbackMailOptin',
        'promotionalMailList',
        'favoriteSearchesMailList',
        'favoriteDealersMailList',
        'tradeMailList',
        'partnerSpotlightsOptin',
    ];

    const hasAnyEmailOptIn =
        preferences &&
        emailOptInPreferences.some(pref => preferences[pref as keyof typeof preferences] === true);

    return !!hasAnyEmailOptIn;
};
